export default {
  methods: {
    renderStoryHtmlToText(html) {
      html = html
        .replace("<br>", " ")
        .replace("<h2>", " ")
        .replace("</h2>", " ")
        .replace("<p>", " ")
        .replace("</p>", " ")
      let div = document.createElement("div")
      div.innerHTML = html
      return div.innerText
    },
    renderStory() {
      let html = "<style>" + this.renderCss() + "</style>"
      html = html + '<div class="sr-story-container sr-story-%TEMPLATE%">'
      switch (this.story.content.template) {
        case "text-over-image":
        case "photo-first":
          html = html + '<img class="sr-story-image" src="%IMGSRC%" alt="story picture">'
          html = html + '<div class="sr-story-html">%CONTENT%</div>'
          break
        case "text-first":
          html = html + '<div class="sr-story-html" >%CONTENT%</div>'
          html = html + '<img class="sr-story-image" src="%IMGSRC%" alt="story picture">'
          break
      }
      html = html.replace("%TEMPLATE%", this.story.content.template)
      html = html.replace("%CONTENT%", this.editorContent)
      html = html.replace("%IMGSRC%", this.story.content.image)

      this.story.content.render = html
    },
    renderCss() {
      return `
      .sr-story-render {
        background-color: white !important;
      }
      .sr-story-container {
        padding: 8px;
        position: relative;
      }
      .sr-story-image {
          width: 100% !important;
      }
      .sr-story-html {
          margin-top: 10px !important;
          padding: 10px !important;
      }
      .sr-story-html > h2 {
          font-size: 2rem !important;
      }
      .sr-story-html > h3 {
          font-size: 1.8rem !important;
      }
      .sr-story-html > h4 {
          font-size: 1.4rem !important;
      }
      .sr-story-html > p {
          font-size: 1rem !important;
      }
      .sr-story-html > ol {
          list-style: revert !important;
      }
      .sr-story-html a {
          text-decoration: underline !important;
      }
      .sr-story-html > ul {
          list-style: revert !important;
      }
      .sr-story-html > ol, .sr-story-html > ul, .sr-story-html > li {
          margin-left: 0 !important;
          padding-left: 20px !important;
      }
      .sr-story-text-first {
      }
      .sr-story-photo-first {
      }      
      .sr-story-text-over-image > .sr-story-html {
            display: block !important;
            position: absolute !important;
            top: 0 !important;
      }
      .sr-story-text-over-image > .sr-story-image {
            z-index:1 !important;
      }
      .sr-story-text-over-image > .sr-story-html {
            z-index:2 !important;
      }
      `
    },
  },
}
